export { default } from './view-publish';
